<template>
	<div class="ranking">
		<h2>Filtros</h2>

		<v-select
			label="Filtrar por sexo"
			:items="['hombre', 'mujer', 'otros']"
			v-model="rankingFilter.gender"
		></v-select>

		<v-range-slider
			class="my-2"
			min="18"
			max="100"
			thumb-label
			v-model="rankingFilter.ageSlider"
			label="Filtrar por edad"
		></v-range-slider>

		<v-range-slider
			class="my-2"
			min="0"
			max="300"
			thumb-label
			v-model="rankingFilter.weightSlider"
			label="Filtrar por peso*"
		></v-range-slider>

		<v-text-field
			v-model="search"
			append-icon="mdi-magnify"
			label="Buscar"
			single-line
			hide-details
		></v-text-field>

		<v-data-table
			:headers="headers"
			:items="computedRanking"
			:search="search"
			:options.sync="options"
			disable-sort
			:footer-props="{
				itemsPerPageOptions: [5, 10, 20],
				itemsPerPageText: 'Usuarios por página',
				pageText: `${1 + options.itemsPerPage * (options.page - 1)}-${
					options.itemsPerPage * (options.page - 1) +
					computedRanking.length
				} de ${computedRanking.length}`,
			}"
		>
			<template #item.rank="{ item }">
				<h2
					:style="{
						color:
							item.rank <= 4
								? `var(--v-accent-darken${item.rank}`
								: 'initial',
					}"
				>
					{{ item.rank }}
				</h2>
			</template>
			<template #item.avatar="{ item }">
				<v-avatar>
					<v-img
						:src="getUserAvatar(item)"
						alt="avatar usuario"
					></v-img>
				</v-avatar>
			</template>

			<template #item.username="{ item }">
				{{ item.username }}
			</template>
			<template #item.time="{ item }">
				<b>{{ item.time | formatTime }}</b>
			</template>
			<template #item.averageSpeed="{ item }">
				{{ item.averageSpeed }} km/h
			</template>
			<template #item.minPerKm="{ item }">
				{{ ((1 / item.averageSpeed) * 60) | formatRate }}
				min/km
			</template>
			<!-- <template #item.score="{item}">
				<v-progress-linear
					rounded
					height="24"
					:color="`rgb(${redValue(item.score)},${greenValue(
						item.score
					)}, 10`"
					:value="(item.score / 10)"
				>
					<template>
						<strong class="white--text"
							>{{ Math.floor(item.score / 10) }}%</strong
						>
					</template>
				</v-progress-linear>
			</template> -->
			<template #no-data>No hay resultados todavía</template>
		</v-data-table>

		<p class="small">
			*Si un usuario no ha registrado peso, al filtrar por peso no
			aparecerán en el ránking
			<!-- <br />
			**Puntuación asignada por nuestro algoritmo -->
		</p>
	</div>
</template>

<script>
import moment from "moment";
export default {
	props: {
		ranking: Array,
		loading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			search: "",
			headers: [
				{
					text: "Ránking",
					value: "rank",
					align: "center",
				},
				{
					text: "Avatar",
					filterable: false,
					sortable: false,
					value: "avatar",
					align: "center",
				},
				{ text: "Usuario", value: "username", align: "center" },
				{ text: "Tiempo", value: "time", align: "center" },
				{
					text: "Velocidad media",
					value: "averageSpeed",
					align: "center",
				},
				{
					text: "Ritmo de carrera",
					value: "minPerKm",
					align: "center",
				},
				/* {
						text: "Puntuación**",
						value: "score",
						align: "center",
					}, */
			],
			options: {},
			rankingFilter: {
				ageSlider: [18, 100],
				gender: null,
				weightSlider: [0, 300],
			},
		};
	},
	computed: {
		computedRanking() {
			let i = 1;
			return this.ranking.filter((el) => {
				el.rank = i;
				if (
					el.age < this.rankingFilter.ageSlider[0] ||
					el.age > this.rankingFilter.ageSlider[1]
				) {
					return;
				}

				if (
					el.weight < this.rankingFilter.weightSlider[0] ||
					el.weight > this.rankingFilter.weightSlider[1]
				) {
					return;
				}

				if (
					this.rankingFilter.gender &&
					el.gender !== this.rankingFilter.gender
				) {
					return;
				}

				i++;
				return el;
			});
		},
	},
	filters: {
		formatDate(value) {
			return moment(value).locale("es").format("LLL");
		},
		formatTime(secs) {
			return moment.utc(secs * 1000).format("HH:mm:ss");
		},
		formatRate(mins) {
			return moment.utc(mins * 60 * 1000).format("mm:ss");
		},
	},
	methods: {
		getUserAvatar(user) {
			return user.avatar;
		},
		greenValue(score) {
			let green = 255 * (1 + (2 * (score - 800)) / 200 - 1);

			if (green > 255) {
				green = 255;
			}
			if (green < 0) {
				green = 0;
			}

			green -= 50;

			return green;
		},

		redValue(score) {
			let red = 255 * (1 - (2 * (score - 800)) / 200 + 1);

			if (red > 255) {
				red = 255;
			}

			if (red < 0) {
				red = 0;
			}

			red += 10;

			return red;
		},
	},
};
</script>

<style lang="scss" scoped>
.small {
	font-size: 0.9em;
	text-align: justify;
	color: var(--v-secondary-lighten4);
}
</style>